import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App.js'
import { fetchConfig } from './config.js'
import './styles.css'

const root = document.querySelector('#root')
if (root === null) throw new Error('No #root element')

const start = async (): Promise<void> => {
  try {
    const config = await fetchConfig()
    createRoot(root).render(
      <StrictMode>
        <App config={config} />
      </StrictMode>,
    )
  } catch (error: unknown) {
    // A misconfigured deployment must say so rather than render a console that
    // silently cannot sign in.
    root.textContent = error instanceof Error ? error.message : 'Failed to start'
  }
}

void start()
